var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopylinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56353 2.33226C3.88155 1.01425 6.01848 1.01425 7.3365 2.33226L9.47731 4.47308C9.74091 4.73668 9.74091 5.16406 9.47731 5.42768C9.2137 5.69128 8.78632 5.69128 8.52271 5.42768L6.3819 3.28686C5.59109 2.49605 4.30893 2.49605 3.51812 3.28686L3.2865 3.51848C2.49568 4.3093 2.49568 5.59146 3.2865 6.38226L5.42731 8.52308C5.69091 8.78668 5.69091 9.21406 5.42731 9.47768C5.1637 9.74128 4.73632 9.74128 4.47271 9.47768L2.3319 7.33686C1.01388 6.01884 1.01388 3.88192 2.3319 2.56388L2.56353 2.33226ZM5.82271 5.82308C6.08632 5.55948 6.5137 5.55948 6.77731 5.82308L12.1773 11.2231C12.4409 11.4867 12.4409 11.9141 12.1773 12.1777C11.9137 12.4413 11.4863 12.4413 11.2227 12.1777L5.82271 6.77768C5.55911 6.51406 5.55911 6.08668 5.82271 5.82308ZM12.5726 8.52308C12.8363 8.25948 13.2637 8.25948 13.5274 8.52308L15.6681 10.6639C16.9862 11.9819 16.9862 14.1189 15.6681 15.4369L15.4365 15.6684C14.1185 16.9866 11.9815 16.9866 10.6635 15.6684L8.52271 13.5277C8.25911 13.2641 8.25911 12.8367 8.52271 12.573C8.78632 12.3095 9.2137 12.3095 9.47731 12.573L11.6181 14.7138C12.4089 15.5047 13.6911 15.5047 14.482 14.7138L14.7135 14.4823C15.5043 13.6915 15.5043 12.4093 14.7135 11.6185L12.5726 9.47768C12.3091 9.21406 12.3091 8.78668 12.5726 8.52308Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylinkWhite);
export default __webpack_public_path__ + "static/media/copylink_white.e7395ea5ef58840f92d9766f4b062de1.svg";
export { ForwardRef as ReactComponent };